export const denormalizePhone = (phone: string): string => {
  if (!phone || typeof phone !== "string") return "";
  if (phone.startsWith("+90")) return "0" + phone.slice(3);
  if (phone.startsWith("90")) return "0" + phone.slice(2);
  return phone;
};